/* eslint-disable no-undef */
import { useState, useEffect } from 'react';

import ShareIcon from '@mui/icons-material/Share';
import { Dialog, Grid, IconButton, Paper, Stack, Typography, Box } from '@mui/material';
import { logEvent } from 'firebase/analytics';

import {
  Investors,
  ReferenceLinks,
  SaleDetails,
  ScreenShots,
  ScreenShotsSection,
  TDHeader,
  TokenVesting
} from '..';
import { LoadingHOC } from '../../common_components';
import analytics from '../../firebase';
import { useFetchIDODetail } from '../../hooks/useClientDataService';
import { useStyles } from '../styles';

import { Tokenomics } from './Tokenomics';

const TokenDetails = () => {
  const [isVisible, setIsVisible] = useState(false);
  const styles = useStyles();

  const { data: tokenDetails, isLoading } = useFetchIDODetail(localStorage.getItem('tokenId'));
  useEffect(() => {
    logEvent(analytics, 'TOKEN_DETAILS_SCREEN');
  }, []);

  if (isLoading) {
    return <LoadingHOC />;
  }

  return (
    <>
      <Box
        elevation={9}
        sx={{ p: { md: 2, sm: 1, xs: 1 }, m: { md: 2, sm: 0.5, xs: 0.5 }, minHeight: '80vh' }}>
        <Dialog
          onClose={() => setIsVisible(false)}
          open={isVisible}
          fullWidth={true}
          PaperProps={{ style: { maxWidth: '99%', maxHeight: '99%' } }}>
          <ScreenShotsSection {...tokenDetails} />;
        </Dialog>
        {process.env.REACT_APP_ENVIRONMENT != 'PRODUCTION' && (
          <Stack alignItems="flex-end">
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={() => setIsVisible(true)}
              sx={{ borderRadius: '50px', height: '40px', width: '40px' }}>
              <ShareIcon sx={{ color: '#3d79e9' }} />
            </IconButton>
          </Stack>
        )}
        <Stack spacing={2}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <TDHeader {...tokenDetails} />
            </Grid>
            {tokenDetails?.alloc_details?.length > 0 && (
              <Paper
                component={Grid}
                sx={{
                  borderRadius: 10,
                  boxShadow: '0 2px 4px -2px rgba(0,0,0,0.24), 0 4px 24px -2px rgba(0, 0, 0, 0.2)',
                  p: { md: 2, sm: 2, xs: 2 },
                  height: '100%',
                  m: 0.5,
                  mt: 1
                }}
                item
                container
                xs={12}
                md={12}
                elevation={9}>
                <Grid item xs={12} md={7.1} sx={{ p: { md: 2, sm: 1, xs: 1 } }}>
                  <Typography variant="h6" gutterBottom component="div">
                    {`TokenVesting Schedule`}
                  </Typography>
                  <TokenVesting {...tokenDetails} />
                </Grid>
                <Grid item xs={12} md={4.9}>
                  <Tokenomics {...tokenDetails} />
                </Grid>
              </Paper>
            )}

            {tokenDetails?.attachments?.length > 0 && (
              <Grid item xs={12} md={6} spacing={1}>
                <ScreenShots {...tokenDetails} />
                {tokenDetails?.ref_links?.length > 0 && <ReferenceLinks {...tokenDetails} />}
              </Grid>
            )}
            {(tokenDetails?.sale_details ||
              tokenDetails?.investors?.length > 0 ||
              tokenDetails?.launch_sites.length > 0 ||
              tokenDetails?.wallets.length > 0) && (
              <Grid item xs={12} md={6} spacing={1}>
                <Stack spacing={2}>
                  {(tokenDetails?.sale_details ||
                    tokenDetails?.launch_sites?.length > 0 ||
                    tokenDetails?.wallets?.length > 0) && <SaleDetails {...tokenDetails} />}
                  {tokenDetails?.investors?.length > 0 && (
                    <Paper
                      sx={{
                        borderRadius: 10,
                        boxShadow:
                          '0 2px 4px -2px rgba(0,0,0,0.24), 0 4px 24px -2px rgba(0, 0, 0, 0.2)',
                        p: { md: 2, sm: 2, xs: 2 }
                      }}
                      elevation={9}
                      className={styles.card}>
                      <Investors {...tokenDetails} />
                    </Paper>
                  )}
                </Stack>
              </Grid>
            )}
          </Grid>
        </Stack>
      </Box>
    </>
  );
};

export default TokenDetails;
